export default __webpack_public_path__ + "static/media/1350.ceb90fe4.png";